<apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
    [legend]="chartOptions.legend" [xaxis]="chartOptions.xaxis" [dataLabels]="chartOptions.dataLabels"
    [title]="chartOptions.title" [grid]="chartOptions.grid" [colors]="chartOptions.colors">
</apx-chart>